import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project import
import Loadable from "../../components/Loadable";
import MinimalLayout from "../../layout/minimal-layout/MinimalLayout";
import TokenService from "../../services/authentication/TokenService";

// render - login
const AuthRegister = Loadable(
    lazy(() => import("../../pages/authentication/Register"))
);
const HomePage = Loadable(
    lazy(() => import("../../pages/home/HomePage"))
);

const HomeRedirect = () => {
    const isAuth = !!TokenService.getData();
    return isAuth ? <Navigate to="/portal" replace /> : <HomePage />;
};

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: "/",
    element: <MinimalLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="/home" replace />,
        },
        {
            path: "home",
            element: <HomeRedirect />,
        },
        {
            path: "login",
            element: <Navigate to="/home" state={{ openLogin: true }} replace />,
        },
        {
            path: "register",
            element: <AuthRegister />,
        },
    ],
};

export default LoginRoutes;
